import utils from "../../utils";
import TopMenu from "../TopMenu";
import CustomIcon from "../CustomIcon";

import React, { useState } from "react";

import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ISubMenuItems, ITopMenuItem } from "../../types/common.interface";

import "./index.scss";
import WalletIcon from "../WalletIcon";
import Context from "../../context";
import { useQuery } from "react-query";
import api from "../../api";
import values from "../../values";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import UserInfo from "../UserInfo";

interface Props {
  children: React.ReactNode;
  topMenuItems: ISubMenuItems[];
}

const Layout = (props: Props) => {
  const navigate = useNavigate();
  const getCurrentMenu = () => window.location.pathname.split("/")[3];

  function getSelectedMenu(): ITopMenuItem {
    const currentMenu = getCurrentMenu();
    return (
      props.topMenuItems.find(
        (menu: any) => menu.pathname.split("/")[3] === currentMenu
      ) || props.topMenuItems[0]
    );
  }

  const [selectedMenu, setSelectedMenu] = useState<ITopMenuItem>(
    getSelectedMenu()
  );

  function onMenuClick(menu: any) {
    navigate(menu.pathname);
    setSelectedMenu(menu);
  }

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  // const balance = Cookies.get(constants.USER.BALANCE);
  // const profitBalance = Cookies.get(constants.USER.PROFIT_BALANCE);

  const result = {};
  // useQuery([values.useQueryKeys.userInfo, userType], () =>
  //   api.get.common.getUserInfo()
  // );

  let userInfo = {};
  // result?.data?.result;

  // switch (userType) {
  //   case "COMPANY":
  //     userInfo = {
  //       ...userInfo,
  //       info: { name: userInfo?.companyInformation?.companyName },
  //     };
  //     break;
  //   case "ADMIN":
  //     userInfo = {
  //       ...userInfo,
  //       info: { name: values.constants.ADMIN_NAME },
  //     };
  //     break;
  //   case "GOVERNMENTSHIP":
  //     userInfo = {
  //       ...userInfo,
  //       info: { name: userInfo?.governmentShipInformation?.name },
  //     };
  //     break;
  //   case "PROVINCE_EDUCATION":
  //     userInfo = {
  //       ...userInfo,
  //       info: { name: userInfo?.provinceEducationInformation?.name },
  //     };
  //     break;
  //   case "SUPER_AGENT_SCHOOL":
  //     userInfo = {
  //       ...userInfo,
  //       info: {
  //         name:
  //           userInfo?.firstName + " " + userInfo?.lastName + "(آموزش و پرورش)",
  //       },
  //     };
  //     break;
  //   case "MUNICIPALITY":
  //     userInfo = {
  //       ...userInfo,
  //       info: {
  //         name: userInfo?.firstName + " " + userInfo?.lastName + "(شهرداری)",
  //       },
  //     };
  //     break;
  // }

  return (
    <Context.UserScreen.Provider value={{ userInfo }}>
      <Container>
        <Container fluid id="layout-container">
          <div className="header-container">
            <div className="actions">
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <CustomIcon
                  hoverTitle={"خروج از حساب"}
                  icon="fa-solid fa-right-from-bracket"
                  size="large"
                  onClick={() => utils.cookiesValue.remove()}
                />
                {/* <UserInfo name={userInfo?.info?.name} />
                <WalletIcon
                  balance={userInfo?.balance?.toString()}
                  profitBalance={userInfo?.companyInformation?.profitBalance?.toString()}
                /> */}
              </div>
            </div>
          </div>
          <section className="screen-wrapper">
            <TopMenu
              onClick={onMenuClick}
              selected={selectedMenu}
              menus={props.topMenuItems}
            />
            <div className="content-wrapper">{props.children}</div>
          </section>
        </Container>
      </Container>
    </Context.UserScreen.Provider>
  );
};

export default Layout;
